import { formatTimeRange } from './dateUtils';

export const TRAINING_SLOT_DURATION_MINUTES = 60;
export const TRAINING_SLOT_START_MINUTES = 8 * 60;
export const TRAINING_SLOT_END_MINUTES = 18 * 60;

export const TRAINING_TIME_SLOTS = Array.from(
  { length: (TRAINING_SLOT_END_MINUTES - TRAINING_SLOT_START_MINUTES) / TRAINING_SLOT_DURATION_MINUTES },
  (_, index) => {
    const minutes = TRAINING_SLOT_START_MINUTES + index * TRAINING_SLOT_DURATION_MINUTES;
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    start.setMinutes(minutes);
    const end = new Date(start.getTime() + TRAINING_SLOT_DURATION_MINUTES * 60 * 1000);

    return { minutes, label: formatTimeRange(start, end) };
  }
);

const toValidDate = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

// Calendar rows are one hour wide, but whether a booking occupies a row always
// comes from the appointment's persisted start and end timestamps.
export const sessionOverlapsSlot = (session, slotStart, durationMinutes = TRAINING_SLOT_DURATION_MINUTES) => {
  const start = toValidDate(session?.start);
  const end = toValidDate(session?.end);
  const slot = toValidDate(slotStart);
  if (!start || !end || !slot || end <= start) return false;

  const slotEnd = new Date(slot.getTime() + durationMinutes * 60 * 1000);
  return start < slotEnd && end > slot;
};

export const sessionStartsInSlot = (session, slotStart, durationMinutes = TRAINING_SLOT_DURATION_MINUTES) => {
  const start = toValidDate(session?.start);
  const slot = toValidDate(slotStart);
  if (!start || !slot) return false;

  const slotEnd = new Date(slot.getTime() + durationMinutes * 60 * 1000);
  return start >= slot && start < slotEnd;
};

export const formatStoredSessionTimeRange = (start, end) => {
  const startDate = toValidDate(start);
  const endDate = toValidDate(end);
  if (!startDate || !endDate) return 'Time unavailable';
  return formatTimeRange(startDate, endDate);
};
